import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { createQuery, queryCache } from '@/queries'
import { getMyStyleData } from '@/features/my-style/api/my-style'
import type { MyStylePageData } from '@/types/my-style'
import type { AxiosResponse } from 'axios'

type MyStyleResponse = Awaited<
  ReturnType<typeof getMyStyleData>
> extends AxiosResponse<infer T>
  ? T
  : never

/** `enabled` — off for a guest on pages that also render signed out (the Favourites brands). */
export const useMyStyleQuery = (enabled: MaybeRefOrGetter<boolean> = true) => {
  return createQuery<MyStyleResponse>({
    key: computed(() => ['my-style']),
    fetcher: async () => {
      const response = await getMyStyleData()
      return response.data
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: computed(() => toValue(enabled))
  })
}


/**
 * T-138 — after a brand like / unlike outside the taste editor (the brand page heart, the
 * Favourites «Brands» tiles): the declared brands list and the picker re-read. The taste
 * caches are NOT touched — a liked brand does not feed recommendations (annotation `3632:70145`).
 */
export function invalidateMyStyleBrandQueries(): void {
  queryCache.invalidate(['my-style'])
  queryCache.invalidate(['available-brands'])
}
